import { FileText } from "lucide-react";
import { RunsList } from "@/components/organisms/reports/RunsList";
import { PageHeader } from "@/components/molecules/PageHeader";

export function ReportsPage() {

  return (
    <div className="flex h-full flex-col gap-4 animate-fade-in bg-background">
      <PageHeader icon={FileText} title="Reports" description="Review completed migration and agent runs, open saved outcomes, and download generated artifacts" />

      <div className="flex-1 min-h-0 overflow-y-auto">
        <RunsList />
      </div>
    </div>
  );
}

export default ReportsPage;
